import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import AccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'
import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import IconButton from '@mui/material/IconButton'
import React, { useState, useCallback } from 'react'

import { StyledAccordion } from './StyledAccordion'
import WorkOrderContent from './WorkOrderContent'
import WorkOrderTabs from './WorkOrderTabs'

type WorkOrderContentProps = React.ComponentProps<typeof WorkOrderContent>

type Props = {
  workOrder?: React.ComponentProps<typeof WorkOrderTabs>['workOrder']
  accountId?: string
  showDivider?: boolean
  cardStyles?: Record<string, unknown>
  contentProps: Omit<WorkOrderContentProps, 'onOpenActionMenu'>
  onOpenActionMenu?: WorkOrderContentProps['onOpenActionMenu']
}

const WorkOrderAccordionItem: React.FC<Props> = ({
  workOrder = {},
  accountId = '',
  showDivider = false,
  cardStyles = {},
  contentProps,
  onOpenActionMenu,
}) => {
  const [isExpanded, setIsExpanded] = useState(false)

  const toggleIsExpanded = useCallback((event: React.MouseEvent) => {
    event.stopPropagation()
    setIsExpanded(prev => !prev)
  }, [])

  return (
    <Box
      sx={{
        borderBottom: showDivider ? '1px solid' : 'none',
        borderColor: 'divider',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
      }}
    >
      <StyledAccordion
        elevation={0}
        expanded={isExpanded}
        slotProps={{ transition: { unmountOnExit: true } }}
        sx={{
          borderBottom: 'none',
          width: '100%',
        }}
      >
        <AccordionSummary sx={{ p: 0, '&.Mui-focusVisible': { background: 'inherit' } }}>
          <Box display="flex" alignItems="center" gap={1} width="100%" px={2} py={1} sx={cardStyles}>
            <IconButton onClick={toggleIsExpanded}>{isExpanded ? <ExpandMoreIcon /> : <ChevronRightIcon />}</IconButton>
            <WorkOrderContent {...contentProps} onOpenActionMenu={onOpenActionMenu} />
          </Box>
        </AccordionSummary>
        <AccordionDetails sx={{ p: 0 }}>
          <Divider />
          <WorkOrderTabs workOrder={workOrder} accountId={accountId} />
        </AccordionDetails>
      </StyledAccordion>
    </Box>
  )
}

export default WorkOrderAccordionItem
